import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from 'react';
import { Wiki } from 'app/containers/Wiki/Wiki.jsx';
export function ProjectWiki(props) {
    const { history, match, location } = props;
    const { projectId } = match.params;
    const formatRoute = useCallback((projectId, assetId, artcileVersionId, search) => `/projects/${projectId || ''}/wiki${assetId ? `/${assetId}` : ''}${artcileVersionId ? `/${artcileVersionId}` : ''}${search || ''}`, []);
    return (_jsx(Wiki, { formatRoute: formatRoute, rootAssetId: projectId || '', history: history, match: match, location: location, showRoot: true, expandedLevel: 1 }));
}
